var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"errors",class:{'input-errors': _vm.errors.length > 0}},[_vm._t("default"),_vm._v(" "),_c('div',[_vm._l((_vm.errors),function(error){return [_c('STErrorBox',{key:error.id},[_vm._v("\n                "+_vm._s(error.human || error.message)+"\n            ")])]})],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }